import MainNav from "../nav/MainNav";

export default function Page({ children }) {
  return (
    <div className="general-container">
      <MainNav />
      {children}
    </div>
  );
}
